module.exports = __webpack_public_path__ + "static/media/fieldWithBanners-SP.71435726.svg";